export default __webpack_public_path__ + "images/about/1 Оксана Вдовина ведущий дизайнер.jpg";